module.exports = __webpack_public_path__ + "static/media/civilnepal.c028ae63.png";